import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Wheel } from "react-custom-roulette";
import logo from "../assets/images/Confidences LOGO- RVB-blanc-ss fond.png";
import axios from 'axios'
import Confetti from 'react-confetti'
import { BaseUrl } from "../constants/BaseUrl";
import { useNavigate } from "react-router-dom";

const data = [
  {
    id: "0",
    option: "SÈCHE-CHEVEUX GHD",
    style: { backgroundColor: "#455560", textColor: "white" },
  },
  {
    id: "1",
    option: "SOIN SPÉCIFIQUE",
    style: { backgroundColor: "#72CCD2", textColor: 'white' },
  },
  {
    id: "2",
    option: "-15%",
    style: { backgroundColor: "#455560", textColor: "white" },
  },
  {
    id: "3",
    option: "SHAMPOING KERASTASE",
    style: { backgroundColor: "#72CCD2", textColor: "white" },
  },
  {
    id: "4",
    option: "-30%",
    style: { backgroundColor: "#455560", textColor: "white" },
  },
  {
    id: "5",
    option: "BAIN TRAITANT",
    style: { backgroundColor: "#72CCD2", textColor: "white" },
  }
];

function Footer() {
  let navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [couponNum, setCouponNum] = useState(1);
  const [mustSpin, setMustSpin] = useState(false);
  const [open, setOpen] = useState(false);
  const [spinView, setSpinView] = useState(true);
  const [emailModal, setEmailModal] = useState(false)
  const [emailFndModal, setEmaiFndlModal] = useState(false)
  const [emailError, setEmailError] = useState(false)
  const [email, setEmailsData] = useState();
  const [onceSend, setOnceSend] = useState(false)
  const [error, setError] = useState(false)
  const [alreadyError, setAlreadyError] = useState('')
  const [alreadyShownError, setAlreadyShownError] = useState(false)
  const screenW = window.screen.width
  const screenH = window.screen.height
  const onHandleChange = (e) => {
    const dataEmail = { ...email };
    dataEmail[e.target.name] = e.target.value;
    setEmailsData({ ...dataEmail });
  }
  useEffect(() => {
    localStorage.setItem("noSpin", true);
    if (localStorage.getItem("spinned")) {
      setSpinView(false)
    }
    if (localStorage.getItem('get')) {
      setOnceSend(true)
    }
  }, []);
  const sendEmailsData = () => {
    const winGift = data[localStorage.getItem('details')].option

    if (email !== undefined && email.email && email.name && winGift) {
      let sendData = {
        email: email.email,
        name: email.name,
        gift: winGift
      }
      axios.post(`${BaseUrl}email/send-email`, sendData).then(res => {
        console.log(res)
        if (res.status === 200) {
          setEmaiFndlModal(false)
          setEmailModal(false)
          localStorage.setItem("get", true)
          setOnceSend(true)
        }
        if (res.status === 201) {
          setAlreadyError(res.data.message)
          setAlreadyShownError(true)
          setTimeout(() => {
            setAlreadyShownError(false)
          }, 5000);
        }
      }).catch(error => {
        if (error) {
          setEmailError(true)
          setTimeout(() => {
            setEmailError(false)
          }, 3000);
        }
      })
    } else {
      setError(true)
      setTimeout(() => {
        setError(false)
      }, 3000);
    }
  }
  const handleCloseEmailModal = () => {
    setEmailModal(false)
  }
  const handleCloseEmailFndModal = () => {
    setEmailFndModal(false)
  }
  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }
  const onClickcoupon = () => {
    console.log("object")
    if (
      localStorage.getItem("noSpin") &&
      localStorage.getItem("instagram") == 10
    ) {
      const newCouponNum = getRandomInt(5);

      if (newCouponNum === 0) {
        setCouponNum(4);
        localStorage.setItem('details', 3)
      } else {
        setCouponNum(newCouponNum);
        localStorage.setItem('details', newCouponNum)
      }

      setMustSpin(true);
    }
    if (
      localStorage.getItem("noSpin") &&
      localStorage.getItem("instagram") === null
    ) {
      setOpenModal(true);
    }
  };
  const redirect = () => {
    navigate("/login");
  }

  return (
    <>
      <div
        className=" w-100 position-absolute d-flex flex-column ng-star-inserted"
        style={{ backgroundColor: "#333F48", overflow: 'hidden', paddingTop:'70px' }}
      >
        {console.log(screenW, screenH,'hamzajsadkAKSK')}
        {spinView === false && <Confetti
          colors={['#72ccd2']}
          width={screenW}
          height={screenH}
        />}
        <div className="h-50 d-flex flex-column justify-content-end align-items-center text-center">
          {/* <div className="bg-logo mb-2 ng-star-inserted" /> */}
          {/* <i  */}
          <img
            className="bg-logo mb-2 ng-star-inserted"
            src={logo}
            alt="logo"
            onDoubleClick={redirect}
          />
          {/* {spinView && <div
            className="fs-4 mb-0 ng-star-inserted font-face-gm"
            style={{
              textTransform: "uppercase",
              fontWeight: 600,
              color: "#ffffff",
              lineHeight: "1.25!important",
            }}y
          >
            TOURNEZ LA ROUE POUR
          </div>} */}
          {spinView === false ? <div
            className="fs-4 mb-0 ng-star-inserted font-face-gm"
            style={{
              textTransform: "uppercase",
              fontWeight: 600,
              color: "#ffffff",
              lineHeight: "1.25!important",
            }}
          >
            BRAVO, C'EST GAGNÉ !
          </div> : ''}
          {spinView === false ? <div
            className="fs-4 mb-0 ng-star-inserted font-face-gm"
            style={{
              textTransform: "uppercase",
              fontWeight: 600,
              color: "#ffffff",
              lineHeight: "1.25!important",
            }}
          ><span style={{ fontFamily: 'sans-serif ', fontSize: '30px' }}>{data[localStorage.getItem('details')].option}</span>
          </div> : ''}
          {spinView === false ?
            onceSend === true &&
            <div
              className="fs-4 mb-0 ng-star-inserted font-face-gm"
              style={{
                textTransform: "uppercase",
                fontWeight: 600,
                color: "#ffffff",
                lineHeight: "1.25!important",
              }}
            >
              Veuillez récupérer le coupon sur votre boîte mail. Vérifiez également le dossier spam.
            </div> : ''}
          {spinView === false ?
            onceSend === false &&
            <div
              className="fs-4 mb-0 ng-star-inserted font-face-gm"
              style={{
                textTransform: "uppercase",
                fontWeight: 600,
                color: "#ffffff",
                lineHeight: "1.25!important",
              }}
            >
              Souhaitez-vous récupérer votre cadeau ou l'offrir à un ami ?
            </div> : ''}
          {spinView && <div
            className="fs-4 mb-0 ng-star-inserted font-face-gm"
            style={{
              textTransform: "uppercase",
              fontWeight: 600,
              color: "#ffffff",
              lineHeight: "1.25!important",
            }}
          >
            DÉCOUVREZ VOTRE CADEAU
          </div>}
          {spinView && <div
            onClick={() => onClickcoupon()}
            className="rounded-pill text-uppercase cursor-pointer fw-bold fs-5 py-2 px-4 lh-sm font-face-gm"
            style={{ color: "#ffffff", backgroundColor: "#72CCD2" }}
          >
            Tourner la roue
          </div>}

        </div>

        <div className="h-50 position-relative ng-star-inserted">
          <div className="row">
            {
              spinView === false ?
                onceSend === false &&
                <div className="d-flex flex-column justify-content-end align-items-center text-center">
                  <div
                    onClick={() => setEmailModal(true)}
                    className="rounded-pill text-uppercase cursor-pointer fw-bold fs-5 py-2 px-4 lh-sm font-face-gm"
                    style={{ color: "#ffffff", backgroundColor: "#72CCD2", margin: '10px 0px' }}
                  >
                    J'EN PROFITE
                  </div>
                  <div
                    onClick={() => setEmaiFndlModal(true)}
                    className="rounded-pill text-uppercase cursor-pointer fw-bold fs-5 py-2 px-4 lh-sm font-face-gm"
                    style={{ color: "#ffffff", backgroundColor: "#72CCD2" }}
                  >
                    L'OFFRIR À UN(E) AMI(E)
                  </div>

                </div>

                : ''
            }
            {spinView && (
              <div className="offset-md-4 ng-tns-c81-0 ng-star-inserted font-face-gm">
                <div style={{ marginLeft: "7%" }}>
                  <Wheel
                    fontSize={13}
                    radiusLineColor="#455560"
                    outerBorderColor="#72CCD2"
                    outerBorderWidth={2}
                    mustStartSpinning={mustSpin}
                    prizeNumber={couponNum}
                    onStopSpinning={() => {
                      setMustSpin(false);
                      // handleOpen();
                      setSpinView(false);
                      localStorage.setItem("spinned", true);
                    }}
                    // mustStartSpinning={mustSpin}
                    // prizeNumber={3}
                    data={data}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Modals */}
        <Modal centered isOpen={openModal}>
          <ModalBody>
            {/* <div className='class="h3 text-uppercase mb-3 text-dark'>
            PARTAGEZ VOTRE EXPÉRIENCE
            </div> */}
            <div className="fw-semi-bold ng-star-inserted font-face-gm">
            Suivez-nous sur Instagram afin de pouvoir tourner la roue et recevoir votre cadeau ! 🎁
            </div>
            <img
              style={{ width: '100%' }}
              src={`https://larouedelafortune.splash360.fr/assets/images/back-arrow.jpg`}
              alt="back-arrow"
              className="img-fluid py-3 ng-star-inserted"
            />
            <a
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                localStorage.setItem("instagram", [10], setOpenModal(false))
              }
              style={{ color: "black", textDecoration: "none" }}
              href="https://www.instagram.com/confidences_le_salon/?hl=fr"
            >
              <div
                className="rounded-pill cursor-pointer text-uppercase fw-semi-bold p-2 ng-star-inserted font-face-gm"
                style={{ backgroundColor: "#72CCD2" }}
              >
                <div style={{ textAlign: 'center', color:'#ffffff' }}> SUIVEZ-NOUS SUR INSTAGRAM</div>
              </div>
            </a>
          </ModalBody>
        </Modal>
        <Modal isOpen={open}>
          <ModalHeader
            close={<button className="btn btn-default" style={{ fontSize: '25px' }} onClick={() => setOpen(false)}>×</button>}
          // toggle={}
          > </ModalHeader>
          <div>
            <h5 hidden>{couponNum}</h5>
            <p style={{ padding: "15px" }}>{data[couponNum].option}</p>
          </div>
        </Modal>
        <Modal  isOpen={emailModal} onClose={handleCloseEmailModal}>
          <ModalHeader
            close={<button className="btn btn-default" onClick={handleCloseEmailModal}>×</button>}
            style={{ backgroundColor: "#72CCD2", fontSize: '25px' }}
          // toggle={}
          >
            <div  style={{color: "#ffffff !important"}} className='h4 text-uppercase mb-3 text-dark font-face-gm'>
              Entrez votre e-mail pour recevoir le cadeau
            </div>
          </ModalHeader>
          <ModalBody 
            style={{color: "#ffffff", backgroundColor: "#72CCD2"}}
            >
            <div>
              <div className="offset-md-2 col-md-8">
                <label className='font-face-gm' htmlFor="review">Prénom</label>
                <input
                  // style={{ padding: "14px 25px" }}
                  type="text"
                  className="form-control"
                  id="name"
                  // placeholder="Name"
                  required
                  name="name"
                  onChange={e => onHandleChange(e)}
                />
              </div>
              <div style={{ marginTop: '10px' }} className="offset-md-2 col-md-8">
                <label className='font-face-gm' htmlFor="review">E-mail</label>
                <input
                  // style={{ padding: "14px 25px" }}
                  type="email"
                  className="form-control"
                  id="email"
                  // placeholder="E-mail"
                  required
                  name="email"
                  onChange={e => onHandleChange(e)}
                />
              </div>
              <div className="offset-md-2 col-md-8" style={{ marginTop: '10px' }}>
                {error && <p style={{ color: 'red' }}> Please Fill the name and email</p>}
                {alreadyShownError && <p style={{ color: 'red' }}>{alreadyError}</p>}
              </div>
              <div className="offset-md-8 col-md-2" style={{ marginTop: '10px' }}>
                {emailError && <p style={{ color: 'red' }}> No recipients defined</p>}
                <button onClick={sendEmailsData} style={{ backgroundColor: '#333f48', color:'#ffffff' }} className="btn btn-default">Recevoir</button>
              </div>
              {/* <p style={{ padding: "15px" }}>{data[couponNum].option}</p> */}
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={emailFndModal} onClose={handleCloseEmailFndModal}>
          <ModalHeader
            style={{color: "#ffffff", backgroundColor: "#72CCD2", fontSize: '25px'}}
            close={<button className="btn btn-default" onClick={handleCloseEmailFndModal}>×</button>}
          // toggle={}
          >
            <div className='h4 text-uppercase mb-3 text-dark font-face-gm'>
            ENTREZ L'E-MAIL DE VOTRE AMI POUR LUI OFFRIR CE CADEAU
            </div>
          </ModalHeader>
          <ModalBody
            style={{color: "#ffffff", backgroundColor: "#72CCD2"}}
            >
            <div>
              <div className="offset-md-2 col-md-8">
                <label htmlFor="review">Prénom de votre ami</label>
                <input
                  // style={{ padding: "14px 25px" }}
                  type="text"
                  className="form-control"
                  id="name"
                  // placeholder="Name"
                  required
                  name="name"
                  onChange={e => onHandleChange(e)}
                />
              </div>
              <div style={{ marginTop: '10px' }} className="offset-md-2 col-md-8">
                <label htmlFor="review">E-mail de votre ami</label>
                <input
                  // style={{ padding: "14px 25px" }}
                  type="email"
                  className="form-control"
                  id="email"
                  // placeholder="E-mail"
                  required
                  name="email"
                  onChange={e => onHandleChange(e)}
                />
              </div>
              <div className="offset-md-2 col-md-8" style={{ marginTop: '10px' }}>
                {error && <p style={{ color: 'red' }}> Please Fill the name and email</p>}
                {alreadyShownError && <p style={{ color: 'red' }}>{alreadyError}</p>}
              </div>
              <div className="offset-md-8 col-md-2" style={{ marginTop: '10px' }}>
                {emailError && <p style={{ color: 'red' }}> No recipients defined</p>}
                <button onClick={sendEmailsData} style={{ backgroundColor: '#333f48', color:'#ffffff' }} className="btn btn-default">Envoyer</button>
              </div>
              {/* <p style={{ padding: "15px" }}>{data[couponNum].option}</p> */}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
}

export default Footer;
